var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageMembershipGoldMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1618_59816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6876 2.02998L21.4286 9.08012C20.8687 9.62389 20.119 9.92806 19.3385 9.92806H12.4444C10.7876 9.92806 9.44444 11.2712 9.44444 12.9281V20.2664C9.44444 21.1053 9.09313 21.906 8.47574 22.474L3.33533 27.2038C2.06734 28.3705 2.04045 30.363 3.27649 31.5635L9.33522 37.4479C9.96825 38.0627 10.2985 38.925 10.2381 39.8054L9.66447 48.1615C9.54547 49.8951 10.9197 51.3669 12.6574 51.3669H21.0712C21.8784 51.3669 22.6515 51.6922 23.2159 52.2692L28.7378 57.9144C29.8735 59.0755 31.7271 59.1219 32.9195 58.019L39.2487 52.1646C39.8032 51.6518 40.5306 51.3669 41.2858 51.3669H50C51.6569 51.3669 53 50.0238 53 48.3669V39.5518C53 38.8207 53.267 38.1148 53.7507 37.5667L59.1074 31.497C60.167 30.2964 60.0969 28.4754 58.9483 27.3598L53.9099 22.4664C53.3282 21.9015 53 21.1252 53 20.3144V12.9281C53 11.2712 51.6569 9.92806 50 9.92806H42.2171C41.4366 9.92806 40.6868 9.62389 40.1269 9.08012L32.8679 2.02998C31.7038 0.899394 29.8517 0.899396 28.6876 2.02998Z",
    fill: "url(#paint0_linear_1618_59816)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.09 34.14C22.11 34.14 22.99 33.75 23.49 33.25V29.92H20.85V31.13H22.17V32.59C21.96 32.76 21.6 32.86 21.24 32.86C19.79 32.86 19.05 31.9 19.05 30.28C19.05 28.7 19.9 27.74 21.14 27.74C21.8 27.74 22.22 28.01 22.59 28.36L23.37 27.41C22.89 26.93 22.15 26.47 21.09 26.47C19.12 26.47 17.54 27.89 17.54 30.33C17.54 32.8 19.08 34.14 21.09 34.14ZM28.018 34.14C29.978 34.14 31.318 32.68 31.318 30.27C31.318 27.87 29.978 26.47 28.018 26.47C26.048 26.47 24.708 27.86 24.708 30.27C24.708 32.68 26.048 34.14 28.018 34.14ZM28.018 32.86C26.908 32.86 26.218 31.85 26.218 30.27C26.218 28.69 26.908 27.74 28.018 27.74C29.118 27.74 29.818 28.69 29.818 30.27C29.818 31.85 29.118 32.86 28.018 32.86ZM32.7733 34H37.2633V32.76H34.2533V26.6H32.7733V34ZM38.5545 34H40.6645C42.8445 34 44.2345 32.76 44.2345 30.27C44.2345 27.77 42.8445 26.6 40.5845 26.6H38.5545V34ZM40.0345 32.81V27.78H40.4845C41.8745 27.78 42.7245 28.47 42.7245 30.27C42.7245 32.07 41.8745 32.81 40.4845 32.81H40.0345Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1618_59816",
    x: 0.366211,
    y: 1.18204,
    width: 61.4922,
    height: 61.6346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1618_59816"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1618_59816",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1618_59816",
    x1: 9,
    y1: 8.5,
    x2: 53,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC9245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC986"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMembershipGoldMain);
export default __webpack_public_path__ + "static/media/image__membership-gold--main.b05f802a30ef5acbea84bf37774b478f.svg";
export { ForwardRef as ReactComponent };